import {
    ANALYZE_COMMUNITY,
    ANALYZE_OVERVIEW,
    LISTENING_COMPETITORS,
    LISTENING_COMPETITOR,
    DASHBOARD,
    DASHBOARD_VIEW,
    DASHBOARD_CUSTOMIZATION,
    DASHBOARD_GENERATE_CUSTOM_REPORT,
    ANALYZE_ENGAGEMENT,
    LISTENING_FEEDS,
    LISTENING_FEED,
    ANALYZE_INDUSTRY_BENCHMARK,
    CONTENT_POSTS,
    ANALYZE_REACH,
    REPORTS,
    REPORTS_EDIT,
    REPORTS_ACCOUNTS,
    REPORTS_DASHBOARDS,
    REPORTS_COMPETITORS,
    REPORTS_HASHTAGS,
    SCHEDULER,
    ANALYZE_CONTENT,
    ANALYZE_VIDEOS,
    ANALYZE_PERFORMANCE,
    ANALYZE_REELS,
    CONTENT_ALBUMS,
    CONTENT_ALBUM_POSTS,
    CONTENT_ALBUM_ANALYTICS,
    MANAGE_COMMENTS_TRACKER,
    SCHEDULER_COLLABORATION,
    SCHEDULER_COLLABORATION_SETTINGS,
    SCHEDULER_COLLABORATION_NOTIFICATIONS,
    CAPTIONS_LISTS,
    MEDIA_LIBRARY,
    CONTENT_ALBUMS_COMPARATIVE_TABLE,
    INSPIRATION,
    CONTENT_ALBUM_STATS
} from '@/routes/privateRoutes';
import { CAMPAIGNS_QUERY_ACTION_PARAM } from '@/lib/albums/queryParams';
import { SCHEDULER_QUERY_ACTION_PARAM } from '@/lib/scheduler/queryParams';
import { aclFeatures } from '@/lib/acl/aclFeatures';
import type { MainMenuType } from '@/lib/menu/main';

const mainFacebook: MainMenuType = [
    // Dashboard
    {
        icon: 'dashboard',
        link: DASHBOARD,
        name: 'commons:menu.dashboard',
        urlActiveMenu: [DASHBOARD_VIEW, DASHBOARD_CUSTOMIZATION, DASHBOARD_GENERATE_CUSTOM_REPORT]
    },
    // Analytics
    {
        icon: 'analytics',
        name: 'menu.analytics',
        subMenuItems: [
            {
                icon: 'eye',
                link: ANALYZE_OVERVIEW,
                name: 'commons:menu.overview'
            },
            {
                icon: 'engagement',
                link: ANALYZE_ENGAGEMENT,
                name: 'commons:menu.engagement'
            },
            {
                icon: 'comments',
                link: ANALYZE_COMMUNITY,
                name: 'commons:menu.community'
            },
            {
                icon: 'content',
                link: ANALYZE_CONTENT,
                name: 'commons:menu.content'
            },
            {
                icon: 'impression',
                link: ANALYZE_REACH,
                name: 'commons:menu.reach'
            },
            {
                icon: 'video',
                link: ANALYZE_VIDEOS,
                name: 'commons:menu.videos'
            },
            {
                icon: 'reel',
                link: ANALYZE_REELS,
                name: 'commons:menu.reels'
            },
            {
                icon: 'performance',
                link: ANALYZE_PERFORMANCE,
                name: 'commons:menu.page_performance'
            }
        ]
    },
    // Reports
    {
        icon: 'reports',
        link: REPORTS,
        name: 'commons:menu.exports_reports',
        urlActiveMenu: [
            REPORTS_EDIT,
            REPORTS_ACCOUNTS,
            REPORTS_DASHBOARDS,
            REPORTS_COMPETITORS,
            REPORTS_HASHTAGS
        ]
    },
    // Content
    {
        icon: 'content',
        name: 'commons:menu.content',
        quickAccess: {
            label: 'commons:menu.track_campaign',
            icon: 'plus',
            link: {
                pathname: CONTENT_ALBUMS,
                query: {
                    [CAMPAIGNS_QUERY_ACTION_PARAM.NAME]:
                        CAMPAIGNS_QUERY_ACTION_PARAM.VALUES.TRACK_CAMPAIGN
                }
            }
        },
        subMenuItems: [
            {
                icon: 'content',
                link: CONTENT_POSTS,
                name: 'commons:menu.posts'
            },
            {
                icon: 'albums',
                link: CONTENT_ALBUMS,
                name: 'commons:menu.albums',
                urlActiveMenu: [
                    CONTENT_ALBUM_POSTS,
                    CONTENT_ALBUM_ANALYTICS,
                    CONTENT_ALBUM_STATS,
                    CONTENT_ALBUMS_COMPARATIVE_TABLE
                ]
            }
        ]
    },
    // Publishing
    {
        icon: 'publishing',
        name: 'commons:menu.publishing',
        quickAccess: {
            label: 'commons:menu.create_post',
            icon: 'plus',
            id: 'quick-access-create-post',
            link: {
                pathname: SCHEDULER,
                query: {
                    [SCHEDULER_QUERY_ACTION_PARAM.NAME]:
                        SCHEDULER_QUERY_ACTION_PARAM.VALUES.CREATE_POST
                }
            }
        },
        subMenuItems: [
            {
                icon: 'publishing',
                link: SCHEDULER,
                name: 'commons:menu.calendar_view'
            },
            {
                icon: 'collaboration',
                link: SCHEDULER_COLLABORATION,
                name: 'commons:menu.collaboration',
                locked: aclFeatures.publishing.external_collaboration.read,
                urlActiveMenu: [
                    SCHEDULER_COLLABORATION_SETTINGS,
                    SCHEDULER_COLLABORATION_NOTIFICATIONS
                ],
                discoverId: 'post_approval'
            },
            {
                icon: 'media-library',
                link: MEDIA_LIBRARY,
                name: 'commons:menu.media_library'
            },
            {
                icon: 'saved',
                link: CAPTIONS_LISTS,
                name: 'commons:menu.saved_captions_lists'
            }
        ]
    },
    // Inspiration
    {
        icon: 'inspiration',
        link: INSPIRATION,
        name: 'commons:menu.inspiration'
    },
    // Conversation
    {
        icon: 'conversations',
        link: MANAGE_COMMENTS_TRACKER,
        name: 'commons:menu.conversations'
    },
    // Listening
    {
        icon: 'listening',
        name: 'commons:menu.listening',
        subMenuItems: [
            {
                icon: 'competitors',
                link: LISTENING_COMPETITORS,
                name: 'commons:menu.competitors',
                urlActiveMenu: [LISTENING_COMPETITOR]
            },
            {
                icon: 'feeds',
                link: LISTENING_FEEDS,
                name: 'commons:menu.feeds',
                urlActiveMenu: [LISTENING_FEED]
            },
            {
                icon: 'industry-benchmark',
                link: ANALYZE_INDUSTRY_BENCHMARK,
                name: 'commons:menu.industry_benchmark'
            }
        ]
    }
];

export default mainFacebook;
